import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')`
  label {
    margin: 0;

    .MuiFormControlLabel-label {
      font-weight: 400;
      font-size: 14px;
      color: ${theme.palette.text.dark};
    }

    .MuiCheckbox-root {
      &.Mui-checked {
        .MuiSvgIcon-root {
          border-color: ${theme.palette.primary.main};
        }
      }

      .MuiSvgIcon-root {
        border: 2px solid ${theme.palette.secondary.main};
        border-radius: 5px;
      }
    }
  }
`;